import type { AppState } from 'state/state.model';

import type { columns, DailyBlotterQuote, Infos } from './dailyBlotter.model';

export function getDailyBlotterQuotesInfo(state: AppState): Infos {
  return state.blotters.dailyBlotter.infos;
}

export function getDailyBlotterQuotesId(state: AppState): string[] {
  return getDailyBlotterQuotesInfo(state).quotesId || [];
}
export function getDailyBlotterQuote(state: AppState, quoteId: string): DailyBlotterQuote {
  return state.blotters.dailyBlotter.quotes[quoteId];
}
export function getDailyBlotterQuotes(state: AppState): DailyBlotterQuote[] {
  const quoteIds = getDailyBlotterQuotesId(state);
  return quoteIds.map(id => getDailyBlotterQuote(state, id)) ?? [];
}

export function getDailyBlotterPaginationInfo(state: AppState): any {
  return {
    page: getDailyBlotterQuotesInfo(state).page,
    itemsPerPage: getDailyBlotterQuotesInfo(state).size,
    totalElements: getDailyBlotterQuotesInfo(state).totalElements,
    totalPages: getDailyBlotterQuotesInfo(state).totalPages,
  };
}

export function getDailyBlotterColumnsDefinition(state: AppState): columns {
  return state.blotters.dailyBlotter.columnDefinitions.columns.filter(c => !c.hide) ?? [];
}
